var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5.125 10.997H.976C.439 10.997 0 10.537 0 10c0-.536.44-.993.976-.993h4.148a4.002 4.002 0 0 1 7.752 0h3.776L14.293 6.69a.962.962 0 0 1-.285-.687c0-.537.46-1.001.996-1.001a.96.96 0 0 1 .698.3l4.005 4.015c.176.176.293.41.293.683a.972.972 0 0 1-.283.693L15.702 14.7a.997.997 0 0 1-.698.297c-.537 0-.996-.453-.996-.99 0-.273.107-.517.283-.692l2.371-2.318h-3.787a4.002 4.002 0 0 1-7.75 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowLinear);
export default __webpack_public_path__ + "static/media/flow-linear.9c923cdef889e3c04692c13225cda7de.svg";
export { ForwardRef as ReactComponent };